import React, { useContext, useEffect, useRef, useState } from "react";
import "./subscription.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Topbar from "../Global/topbar";
import TableBody2 from "../Table container/tablebody";
import CachedIcon from "@mui/icons-material/Cached";
// import { handleToast } from "../../utils";
// import { toast } from "react-toastify";
// import { deleteRecharge, getRechages } from "../../services/api/recharges";
import { getSubscription } from "../../services/api/subscription";
import { Context } from "../../context/contextapi";

export default function Subscription() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const menu = true;
  // eslint-disable-next-line
  const [skip, setSkip] = useState(0);
  // eslint-disable-next-line
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [reload, setReload] = useState();
  const [pages, setPages] = useState("");
  const disabled = true;
  const deleted = true;
  // const isMobile = window.innerWidth <= 600;
  const start_key = useRef({ 1: null });
  const page = useRef(1);
  const location = useLocation();
  const { setHasmore} = useContext(Context);
  useEffect(() => {
    setPages((prev) => !prev);
  }, [search]);

  useEffect(() => {
    const start = JSON.parse(sessionStorage.getItem("start_key"));
    const URI = JSON.parse(sessionStorage.getItem("path"));
    if (start && location.pathname === URI) {
      start_key.current = start;
    } else {
      start_key.current = { 1: null };
    }
  }, [location]);

  const fetchRecharges = async () => {
    const paginationKey = start_key.current[page.current];
    getSubscription(search, limit, paginationKey)
      .then((response) => {
        if (response.data.status === "success") {
          if (response?.data?.data?.data.length === 0) {
            setLoder(false);
            setNotFound(true);
            setData(true);
            setTotal(response?.data?.data?.total);
            setHasmore(false);
          } else {
            setLoder(false);
            setNotFound(false);
            setData(true);
            setTotal(response?.data?.data?.total);
            setAPIdata(response?.data?.data?.data || []);
            start_key.current[page.current + 1] =
              response?.data?.data.last_key || null;
              if(response?.data?.data?.last_key ){
             setHasmore(true);
            }else{
             setHasmore(false)
            }
            sessionStorage.setItem(
              "start_key",
              JSON.stringify(start_key.current)
            );
          }
        } else {
          setLoder(false);
          setHasmore(false);
          setNotFound(true);
        }
      })
      .catch((error) => {
        setLoder(false);
        setNotFound(true);
        setHasmore(false);
        console.log(error.message);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoder(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchRecharges();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [search, reload, skip, limit]);

  const handleclick = () => {
    navigate("/admin/subscription/create_subscription");
  };

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  const handleDeleted = async (id) => {
    // setReload((prev) => !prev);
    // try {
    //   deletesubscription(id)
    //     .then(() => {
    //       toast.success("Success! subscription deleted", {
    //         position: isMobile ? "top-left" : "top-center",
    //         style: {
    //           width: isMobile ? "300px" : "400px",
    //           textWrap: isMobile && 'wrap',
    //         },
    //       });
    //     }).catch((error) => {
    //       handleToast(error);
    //     });
    // } catch (error) {
    //   handleToast(error);
    //   console.log(error.message);
    // }
  };

  const headers = [
    { topic: "#" },
    { topic: "Name" },
    { topic: "Base Price" },
    { topic: "Final Price" },
    { topic: "Duration" },
    { topic: "Timeframe" },
    { topic: "Discount %" },
    { topic: "Trial Days" },
    { topic: "Trial Charge" },
    { topic: "Status" },
    { topic: "Is Default" },
    { topic: "Created At" },
    { topic: "Action" },
  ];
  const cell = [
    { topic: "name" },
    { topic: "base_price" },
    { topic: "final_price" },
    { topic: "duration" },
    { topic: "timeframe" },
    { topic: "discount_percentage" },
    { topic: "trial_days" },
    { topic: "trial_charge" },
    { topic: "status" },
    { topic: "is_default" },
    { topic: "created_at" },
  ];
  const path = "/admin/subscription/subscription_detail";

  return (
    <div className="subscription-top-main">
      <div className="mainbar-subscription-top">
        <Topbar />
        <div className="top-mid-user">
          <h1>Subscriptions List</h1>
          <Link href="" style={{ display: "none" }}>
            Dashboard
          </Link>{" "}
          <Link to="/admin/subscription">Subscriptions List</Link> &#62;
        </div>
        <div className="tob-btm-user">
          <div className="button-box-user">
            <button onClick={handleclick}> + Create Subscription</button>
          </div>
          <div>
            <input
              type="text"
              className="input1"
              placeholder="&#61442; Search"
              onChange={(e) => {
                setSearch(e.target.value);
                setSkip(0);
                start_key.current[1] = undefined;
                page.current = 1;
                sessionStorage.setItem('newPage',1)
              }}
              style={{ fontfamily: "Arial, FontAwesome" }}
            />{" "}
            <button onClick={handleReload}>
              {" "}
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path={path}
            loader={loader}
            notfound={notfound}
            data={data}
            menu={menu}
            setSkip={setSkip}
            total={total}
            setLimit={setLimit}
            pages={pages}
            disabled={disabled}
            deleted={deleted}
            handleDeleted={handleDeleted}
            newPage={page}
            setReload={setReload}
            search={search}
          />
        </div>
      </div>
    </div>
  );
}
